// Theme: cloud-dancer
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cloud-dancer',
  name: 'CLOUD DANCER',
  tagline: 'CLOUD DANCER',
  description: 'Pessego etereo em versao free BP com glow discreto.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#1A1008', '#2A1C10', '#FDBA74', '#FFF7ED'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-cloud-dancer'
  },
  colorVars: {
    '--accent': '#FDBA74',
    '--accent-foreground': '#1A1008',
    '--background': '#1A1008',
    '--border': '#8A5030',
    '--card': '#2A1C10',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF7ED',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1008',
    '--foreground': '#FFF7ED',
    '--hold-fill': '#FDBA74',
    '--input': '#8A5030',
    '--modal-bg': '#1A1008',
    '--modal-border': '#8A5030',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A5030',
    '--muted-foreground': '#FFF7ED',
    '--nav-active': '#FDBA74',
    '--nav-bg': '#2A1C10',
    '--popover': '#2A1C10',
    '--popover-foreground': '#FFF7ED',
    '--primary': '#FDBA74',
    '--primary-foreground': '#1A1008',
    '--ring': '#FDBA74',
    '--secondary': '#8A5030',
    '--secondary-foreground': '#FFF7ED',
    '--streak': '#FDBA74',
    '--success': '#22c55e',
    '--success-foreground': '#1A1008',
    '--xp': '#FDBA74',
    '--xp-bg': '#2A1C10'
  },
  resolvedVars: {
    '--accent': '#FDBA74',
    '--accent-foreground': '#1A1008',
    '--accent-foreground-hsl': '27 53% 7%',
    '--accent-foreground-oklch': 'from #1A1008 l c h',
    '--accent-hsl': '31 97% 72%',
    '--accent-oklch': 'from #FDBA74 l c h',
    '--background': '#1A1008',
    '--background-hsl': '27 53% 7%',
    '--background-oklch': 'from #1A1008 l c h',
    '--border': '#8A5030',
    '--border-hsl': '21 48% 36%',
    '--border-oklch': 'from #8A5030 l c h',
    '--border-w': '1px',
    '--card': '#2A1C10',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF7ED',
    '--card-foreground-hsl': '33 100% 96%',
    '--card-foreground-oklch': 'from #FFF7ED l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '28 45% 11%',
    '--card-oklch': 'from #2A1C10 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1008',
    '--destructive-foreground-hsl': '27 53% 7%',
    '--destructive-foreground-oklch': 'from #1A1008 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFF7ED',
    '--foreground-hsl': '33 100% 96%',
    '--foreground-oklch': 'from #FFF7ED l c h',
    '--hold-fill': '#FDBA74',
    '--hold-fill-hsl': '31 97% 72%',
    '--hold-fill-oklch': 'from #FDBA74 l c h',
    '--input': '#8A5030',
    '--input-hsl': '21 48% 36%',
    '--input-oklch': 'from #8A5030 l c h',
    '--modal-bg': '#1A1008',
    '--modal-bg-hsl': '27 53% 7%',
    '--modal-bg-oklch': 'from #1A1008 l c h',
    '--modal-border': '#8A5030',
    '--modal-border-hsl': '21 48% 36%',
    '--modal-border-oklch': 'from #8A5030 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A5030',
    '--muted-foreground': '#FFF7ED',
    '--muted-foreground-hsl': '33 100% 96%',
    '--muted-foreground-oklch': 'from #FFF7ED l c h',
    '--muted-hsl': '21 48% 36%',
    '--muted-oklch': 'from #8A5030 l c h',
    '--nav-active': '#FDBA74',
    '--nav-active-hsl': '31 97% 72%',
    '--nav-active-oklch': 'from #FDBA74 l c h',
    '--nav-bg': '#2A1C10',
    '--nav-bg-hsl': '28 45% 11%',
    '--nav-bg-oklch': 'from #2A1C10 l c h',
    '--popover': '#2A1C10',
    '--popover-foreground': '#FFF7ED',
    '--popover-foreground-hsl': '33 100% 96%',
    '--popover-foreground-oklch': 'from #FFF7ED l c h',
    '--popover-hsl': '28 45% 11%',
    '--popover-oklch': 'from #2A1C10 l c h',
    '--primary': '#FDBA74',
    '--primary-foreground': '#1A1008',
    '--primary-foreground-hsl': '27 53% 7%',
    '--primary-foreground-oklch': 'from #1A1008 l c h',
    '--primary-hsl': '31 97% 72%',
    '--primary-oklch': 'from #FDBA74 l c h',
    '--radius': '10px',
    '--ring': '#FDBA74',
    '--ring-hsl': '31 97% 72%',
    '--ring-oklch': 'from #FDBA74 l c h',
    '--secondary': '#8A5030',
    '--secondary-foreground': '#FFF7ED',
    '--secondary-foreground-hsl': '33 100% 96%',
    '--secondary-foreground-oklch': 'from #FFF7ED l c h',
    '--secondary-hsl': '21 48% 36%',
    '--secondary-oklch': 'from #8A5030 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#FDBA74',
    '--streak-hsl': '31 97% 72%',
    '--streak-oklch': 'from #FDBA74 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A1008',
    '--success-foreground-hsl': '27 53% 7%',
    '--success-foreground-oklch': 'from #1A1008 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(31 97% 72% / 0.15)',
    '--xp': '#FDBA74',
    '--xp-bg': '#2A1C10',
    '--xp-bg-hsl': '28 45% 11%',
    '--xp-bg-oklch': 'from #2A1C10 l c h',
    '--xp-hsl': '31 97% 72%',
    '--xp-oklch': 'from #FDBA74 l c h'
  }
}
